<template>
  <div class="content home-page">
    <Header></Header>
    <div class="chances-top disflex crfff ac">
      <div @click="back">
        <img width="20" src="../../static/images/back.png" class="nav-icon-left"/>
        <div>{{ $t('Back') }}</div>
      </div>
    </div>
    <div class="information2">
      <div class="faq-content" v-if="list!=''">
        <div style="text-align: center">
          <p class="mt30" >
            <span class="fs50">{{msg}}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from '../components/Header'

export default {
  components: {
    Header
  },
  data() {
    return {
      msg: ''

    }
  },
  watch: {},
  computed: {},
  mounted() {
    let that = this;
  },
  created() {
    this.msg = this.$route.query.msg
  },
  methods: {
    back() {
      this.$router.go(-1);
    },

  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/error.vue